// eslint-disable-next-line import/prefer-default-export
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const getFormPagePath = (path: string, segment: string): string => {
  if (path === '/') {
    return `/${segment}`;
  }
  return `${path}/${segment}`;
};

export const navigateToError = (): void => {
  const paths = window.location.pathname.split('/');
  if (paths[paths.length - 1].includes('step')) {
    paths[paths.length - 1] = 'error';
  }
  const navUrl = paths.join('/');
  window.location.href = navUrl;
  window.scrollTo(0, 0);
};

export const navigateToNextStep = (navigate: any, location: any, destination: 'next' | 'previous'): void => {
  const pathname = location.pathname.split('/');
  if (pathname[pathname.length - 1].includes('step')) {
    const lastSegment = pathname[pathname.length - 1];
    const currentPageNoRegex = new RegExp('[^(step)]*$');
    let nextPage: number;
    if (destination === 'next') nextPage = parseInt(lastSegment.match(currentPageNoRegex), 10) + 1;
    else nextPage = parseInt(lastSegment.match(currentPageNoRegex), 10) - 1;
    pathname[pathname.length - 1] = `step${nextPage}`;
  }
  const navUrl = pathname.join('/');
  if (destination === 'next') {
    navigate(navUrl);
    window.scrollTo(0, 0);
  } else {
    navigate(navUrl, { replace: true });
    window.scrollTo(0, 0);
  }
};
export const navToError = (navigate: any, location: any): void => {
  const paths = location.pathname.split('/');
  if (paths[paths.length - 1].includes('step')) {
    paths[paths.length - 1] = 'error';
  }
  const navUrl = paths.join('/');
  navigate(navUrl, { replace: true });
  window.scrollTo(0, 0);
};

export const navigateToSpecificSteps = (navigate: any, location: any, destination: any): void => {
  const pathname = location.pathname.split('/');
  if (pathname[pathname.length - 1].includes('step')) {
    pathname[pathname.length - 1] = `step${destination}`;
  }
  const navUrl = pathname.join('/');
  if (destination) {
    navigate(navUrl);
    window.scrollTo(0, 0);
  }
};
